<!--

Size:
default
large
small

Classes:
primary
secondary
icon
no-label
ghost

State:
:hover / hover
:active / active
:disabled / disabled
:invalid / negative

-->

<button
  [type]="type"
  [disabled]="disabled || status === 'loading'"
  [ngClass]="['sp-button', style, status === 'error' ? 'negative' : state || '', size || '']"
  (click)="onClickEvent($event)"
>
  <sp-icon *ngIf="icon" class="sp-button-icon icon icon-right" size="small" [inherit]="true" [name]="icon" type="solid"></sp-icon>
  <sp-icon
    *ngIf="status === 'error'"
    class="sp-button-icon icon icon-right"
    size="small"
    [inherit]="true"
    [name]="'remove-circle-2'"
    type="solid"
  ></sp-icon>
  <sp-icon
    *ngIf="status === 'success'"
    class="sp-button-icon icon icon-right"
    size="small"
    [inherit]="true"
    [name]="'check-circle-2'"
    type="solid"
  ></sp-icon>
  <span class="sp-button-label">
    {{ label }}
    <ng-content></ng-content>
  </span>
  <i *ngIf="status === 'loading'" class="loading"></i>
</button>
<span class="hover-blur"></span>
